export default "__VITE_ASSET__DnI4Ioyw__"